import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { Router } from '@angular/router';
import { AppSettings } from '../../providers/app-settings';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginUsername: string;
  loginPassword: string;
  ErrorMsg = '';

  constructor(private loginService: LoginService, private router: Router, private appSettings: AppSettings) { }

  ngOnInit() {
  }

  login() {
    if (this.loginUsername && this.loginPassword) {
      this.loginService.login(this.loginUsername, this.loginPassword).subscribe((response) => {
        const userCredentials = response.json();
        this.appSettings.apiHeaders.set('X-Access-Token', userCredentials.apiKey);
        this.appSettings.setLoginStatus(true);
        this.router.navigate(['/']);
      }, (error: any) => {
        if (error.status === 404) {
          this.ErrorMsg = 'The username you provided has not been found on the portal.';
        } else if (error.status === 403) {
          this.ErrorMsg = 'Invalid password for the given username.';
        } else {
          this.ErrorMsg = 'Unexpected server error.';
        }
      });
    } else {
      this.ErrorMsg = 'UserName And Password Are Required.';
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/login/login.component.ts